// Production App chrome lives in the resource iframe; its conversation lives
// in the AIOS host. A local send_update cannot reach that parent's LiveView.
//
// Standalone, the FIRST click mounts the drawer on the server (it opens on
// mount) and the next ones toggle it. Mounting takes a moment, so the button
// shows it is opening and swallows repeat clicks until the server replies: a
// click queued behind the mount reached the server as a toggle and closed the
// drawer it had just opened — it took three clicks to see it (2026-10-26).
// The flag lives on <html>, which LiveView never patches.
const OPENING_TIMEOUT_MS = 15000

const AppAgentLauncher = {
  mounted() {
    this.openAgent = event => {
      if (!event.target.closest("button")) return
      if (window.self !== window.parent) {
        window.parent.postMessage({type: "seiva:committee:app-agent"}, window.location.origin)
        return
      }
      if (this.opening) return
      if (document.getElementById("monica-drawer")) {
        this.pushEvent("toggle_app_runtime_agent", {})
        return
      }
      this.startOpening()
      this.pushEvent("toggle_app_runtime_agent", {}, () => this.settleThenStop())
    }
    this.el.addEventListener("click", this.openAgent)
  },
  startOpening() {
    this.opening = true
    document.documentElement.dataset.appAgentOpening = "true"
    this.el.querySelector("button")?.setAttribute("aria-busy", "true")
    // No reply (socket dropped mid-mount): give the button back.
    this.openingTimer = setTimeout(() => this.stopOpening(), OPENING_TIMEOUT_MS)
  },
  // The reply lands when the drawer is in the DOM, but it is still sliding in:
  // a click during the slide would toggle it shut, so wait for its transition.
  settleThenStop() {
    const drawer = document.getElementById("monica-drawer")
    const durations = drawer ? getComputedStyle(drawer).transitionDuration.split(",").map(parseFloat) : [0]
    const ms = Math.min(1000, Math.max(0, ...durations.filter(Number.isFinite)) * 1000)
    clearTimeout(this.openingTimer)
    this.openingTimer = setTimeout(() => this.stopOpening(), ms + 50)
  },
  stopOpening() {
    if (!this.opening) return
    this.opening = false
    clearTimeout(this.openingTimer)
    delete document.documentElement.dataset.appAgentOpening
    this.el.querySelector("button")?.removeAttribute("aria-busy")
  },
  destroyed() {
    this.el.removeEventListener("click", this.openAgent)
    this.stopOpening()
  },
}

export default AppAgentLauncher
